<template>
  <el-dialog
    :title="$t('공지사항')"
    :visible.sync="notiDialogVisible"
    :width="$device.tablet ? '90%' : '600px'"
    class="noti-dialog"
    :close-on-click-modal="false">
    <el-collapse v-model="collapse_val" v-for="(noti, index) in notiData" :key="'noti_' + index" accordion>
      <el-collapse-item :name="index">
        <template slot="title">
          <el-badge value="new" v-if="isNew(noti.startDtm)">
            <div class="noti-title">{{ '[ ' + noti.startDtm + ' ] ' + noti.notiTitle }}</div>
          </el-badge>

          <div class="noti-title" v-else>{{ '[ ' + noti.startDtm + ' ] ' + noti.notiTitle }}</div>
        </template>
        <div v-html="noti.content" class="noti-content"></div>
      </el-collapse-item>
    </el-collapse>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="notiDisabled">{{ $t('해당 공지 이제 그만보기') }}</el-button>
      <el-button @click="notiDialogVisible = false" size="small">{{ $t('닫기') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkAuthActionAccess } from '@/utils/checkAuthActionAccess'
import { isNew } from '@/utils/isNew'

export default {
  data() {
    return {
      notiDialogVisible: false,
      notiData: [],
      collapse_val: 0,
    }
  },
  computed: {
    ...mapGetters({
      authId: 'auth/authId',
      auth: 'auth/auth',
    }),
  },

  mounted() {
    // 공지 리소스가 없는 역할(콜팝 4종)은 **부르지 않는다** — 보안 계층의 403 은 서버가 세션을 끊어서
    // 뒤따르는 모든 호출을 못 쓰게 만든다(서버 보고서 §5 함정). `sa_actions` 가 부를 수 있는지 답한다.
    if (!checkAuthActionAccess('NotiGetShowData')) return

    if (this.authId !== 'storeMng' || this.auth.agreeYn) {
      this.showNoti()
    }
  },
  methods: {
    isNew,
    async showNoti() {
      const result = await this.$axios.get('/noti/showNotiData').then((res) => res.data)

      // 쿠키에서 숨심 공지 체크해서 걸러줌
      var arr,
        reg = new RegExp('(^| )noti=([^;]*)(;|$)')
      var disabledNotis = ''

      if ((arr = document.cookie.match(reg))) {
        disabledNotis = unescape(arr[2])
      }

      var tmp = []

      for (var i = 0, len = result.length; i < len; i++) {
        if (disabledNotis.indexOf(',' + result[i].notiCd) == -1) {
          tmp.push(result[i])
        }
      }

      if (tmp.length > 0) {
        this.notiDialogVisible = true
        this.notiData = tmp
      }
    },
    notiDisabled() {
      var value = ''

      // 쿠키에서 숨심 공지 체크해서 걸러줌
      var arr,
        reg = new RegExp('(^| )noti=([^;]*)(;|$)')

      if ((arr = document.cookie.match(reg))) {
        value = unescape(arr[2])
      }

      for (var i = 0, len = this.notiData.length; i < len; i++) {
        value += ',' + this.notiData[i].notiCd
      }

      // 쿠키에 안보는 공지코드 저장 함
      var exp = new Date()
      exp.setTime(exp.getTime() + 365 * 24 * 60 * 60 * 1000)
      document.cookie = 'noti=' + escape(value) + ';expires=' + exp.toGMTString()

      this.notiDialogVisible = false
    },
  },
}
</script>

<style scoped>
.noti-dialog .el-dialog__header {
  border-bottom: 1px solid #dadde4;
}
.noti-dialog .el-dialog__body {
  overflow: auto;
  height: 400px;
}
.noti-dialog .el-dialog__footer {
  border-top: 1px solid #dadde4;
}
.noti_div {
  padding: 20px;
  border-top: 1px solid #dadde4;
  overflow: auto;
  height: 300px;
}

.noti-title {
  padding: 0 20px;
  width: 100%;
}

.noti-content {
  padding: 20px 40px;
}

@media (max-width: 1280px) {
  .noti-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .noti-dialog::v-deep .el-dialog {
    margin: 0px !important;
  }
  .noti-dialog::v-deep .noti-content {
    padding: 10px;
  }

  .noti-dialog::v-deep .noti-title {
    padding: 0;
    line-height: 1.2;
  }
}
</style>
